<template>
  <div class="top-filter-and-block mdl-card__supporting-text">
    <button v-if="parent"
            class="mdl-button mdl-js-button mdl-button--fab mdl-button--raised mdl-button--accent delete-button"
            v-on:click="deleteThis">
      <i class="material-icons">delete_forever</i>
    </button>
    <div class="block ">

      <div class="blockLeft">

        <SingleSelect :value="operatorObject(expression.type)" @update:value="setType"
                      :options="possibleOperators" :display="o => i18n().operators[o.title] || 'i18n:'+o.title"></SingleSelect>

        <!--<select :value="expression.type" @change="setType">
          <option v-for="operator in possibleOperators" v-bind:value="operator.name">{{ operator.title }}</option>
        </select>-->

      </div>

      <div class="blockArgs">

        <div class="arg" v-for="(arg, argId) in expression.args">

          <div class="andLine" v-if="argId > 0">{{ i18n().andLine }}<div class="line"></div></div>
          <FilterExpression :expression="arg" @update:expression="setArg(argId, $event)" :columns="columns"
                             :parent="definition" @delete="deleteArg(argId)" @addAnd="addArg(argId)"></FilterExpression>

  <!--    <button class="mdl-button add-button" v-if="definition.isList" v-on:click="addArg(argId)">
            <i class="material-icons">add</i> AND
          </button>-->
        </div>

      </div>

    </div>
  </div>
</template>

<script>
import expression from "../../logic/expression.js"
import TopFilterOrBlock from "./TopFilterOrBlock"
import SingleSelect from "../utils/SingleSelect.vue"
import i18n from "i18n"

export default {
  name: 'top-filter-and-block',
  props: {
    columns: {
      type: Array,
      default: function () {
        return []
      }
    },
    expression: {
      type: Object,
      default: function() {
        return {
          type: "and",
          args: []
        }
      }
    },
    parent: {
      type: Object,
      default: function() {
        return null
      }
    }
  },
  components: {
    FilterExpression: TopFilterOrBlock,
    SingleSelect
  },
  data () {
    return {
      possibleOperators: [
        { name: 'and', title: 'include' },
        { name: 'nand', title: 'exclude' }
      ]
    }
  },
  computed: {
    definition() {
      return expression.operatorsByName.get(this.expression.type)
    }
  },
  watch: {
  },
  methods: {
    i18n() {return i18n().filter },
    operatorTitle(name) {
      for(let op of this.possibleOperators) {
        if(op.name == name) return op.title
      }
    },
    operatorObject(name) {
      for(let op of this.possibleOperators) {
        if(op.name == name) return op
      }
    },
    operatorDefinition(expr) {
      const operator = expression.operatorsByName.get(expr.type)
      console.log("OP", operator)
      return operator
    },
    addArg(at) {
      var nArg = {
        "type": "or",
        args: [
          {
            "type": ">",
            "args": ["Count", 100]
          }
        ]
      }
      var nArgs = this.expression.args.slice()
      nArgs.splice(at + 1, 0, nArg)
      this.$emit('update:expression', {
        type: this.expression.type,
        args: nArgs
      })
    },
    setArg(argId, ev) {
      console.log("SET ARG", argId, ev)
      const nArgs = this.expression.args.slice()
      nArgs[argId] = ev
      this.$emit('update:expression', {
        type: this.expression.type,
        args: nArgs
      })
    },
    deleteArg(argId) {
      console.log("DELETE ARG", argId)
      const nArgs = this.expression.args.slice()
      nArgs.splice(argId, 1)
      if(nArgs.length == 0) return this.deleteThis()
      this.$emit('update:expression', {
        type: this.expression.type,
        args: nArgs
      })
    },
    setType(value) {
      let nType = value.name
      var nDefinition = expression.operatorsByName.get(nType)
      console.log("SET TYPE", nType)
      if(!this.definition.isLogical && nDefinition.isLogical) {
        this.$emit('update:expression', {
          type: nType,
          args: [JSON.parse(JSON.stringify(this.expression))]
        })
      } else if(this.definition.isLogical && !nDefinition.isLogical) {
        this.$emit('update:expression', {
          type: nType,
          args: [nDefinition.defaultArgs(this.columns)]
        })
      }/* else if ((this.definition.element != nDefinition.element)
        || (this.definition.left != nDefinition.left)
        || (this.definition.right != nDefinition.right)) {
        console.log("RESET ARGS")
        this.$emit('update:expression', {
          type: nType,
          args: nDefinition.defaultArgs(this.columns)
        })
      }*/ else {
        console.log("HOLD ARGS")
        this.$emit('update:expression', {
          type: nType,
          args: this.expression.args
        })
      }
    },
    deleteThis() {
      this.$emit('delete')
    }

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .top-filter-and-block {
    position: relative;
    padding-top: 0.1em;
    padding-bottom: 0.1em;
    overflow: visible;
    width: 100%;
  }

  .block {
    display: flex;
    flex-direction: row;
  }

  .block > .blockLeft {
    max-width: 120px;
    margin-right: 10px;
  }
  .block > .blockArgs {
    width: 100%;

  }

  .andLine {
    line-height: 1em;
    font-size: 0.85em;
    position: relative;
    text-transform: uppercase;
  }

  .andLine .line {
    display: block;
    position: absolute;
    left: 41px;
    right: 0px;
    top: 5px;
    height: 1px;
    width: auto;
    background: lightgray;
  }

  .delete-button {
    position: absolute;
    right: -22px;
    top: -6px;
    width: 28px;
    max-width: 28px;
    min-width: 28px;
    height: 28px;
  }
  .delete-button i {
    font-size: 20px;
  }

</style>



// WEBPACK FOOTER //
// TopFilterAndBlock.vue?d8faea18